import React from "react";
import { t } from "i18next";
import moment from "moment";

import { FORM_FIELD, SUBHEADING_FIELD } from "@constants/register";
import { DateFormats } from "@enums/shared.enum";
import { InputFieldProps } from "@models/shared/shared.model";

const InputField: React.FC<InputFieldProps> = ({
  className,
  disabled = false,
  errors,
  id,
  label,
  maxLength = 100,
  name,
  placeholder,
  register,
  registerOptions,
  type,
}) => {
  return (
    <>
      <input
        type={type}
        className={className}
        id={id}
        placeholder={placeholder || label}
        {...register(name, registerOptions[name])}
        data-testid="inputField"
        max={moment().subtract(5, "years").format(DateFormats.YMD)}
        disabled={disabled}
        maxLength={maxLength}
        {...(name === SUBHEADING_FIELD.EMAIL ? { spellCheck: false } : {})}
      />
      <label htmlFor={name as string}>{label}*</label>
      {label == t("mainEmail") && <i className="fa-solid fa-envelope"></i>}
      {type === FORM_FIELD.DATE_FIELD && (
        <i className="fa-regular fa-calendar-days" />
      )}
      {errors[name] && (
        <div className="invalid-feedback" data-testid="error">
          {errors[name].message}
        </div>
      )}
    </>
  );
};

export default InputField;
